export const BaseIntervalStatus = {
  planned: 'planned',
  active: 'active',
  ended: 'ended',
} as const;

export type BaseIntervalStatusType = typeof BaseIntervalStatus[keyof typeof BaseIntervalStatus];
